import React from "react";
import { Stack, Tab, Tabs } from "convertupleads-theme";
import ColoredIcons from "./ColoredIcons";
import OutlinedIcons from "./OutlinedIcons";
import FilledIcons from "./FilledIcons";

const IconList = () => {
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack direction={"column"} spacing={2} p={1}>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{ px: 2, borderBottom: 1, borderColor: "other.outlinedBorder" }}
      >
        <Tab label="Outlined" value={1} />
        <Tab label="filled" value={2} />
        <Tab label="Colored" value={3} />
      </Tabs>

      {/*<Box sx={{ width: "100%%", alignSelf: "center" }}>*/}
      {value === 1 && <OutlinedIcons />}
      {value === 2 && <FilledIcons />}
      {value === 3 && <ColoredIcons />}
      {/*</Box>*/}
    </Stack>
  );
};

export default IconList;
